import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { SgKdSharedRoutingModule } from './sg-kd-shared-routing.module';
import { SharedModule } from 'cbc-shared-lib';
import { SgBaseSharedModule } from '../../sg-base/sg-base-shared/sg-base-shared.module';

import { BillDispZyuusyoPipe } from './pipes/bill-disp-zyuusyo.pipe';
import { DateDurationPipe } from './pipes/date-duration.pipe';


@NgModule({
  declarations: [
    BillDispZyuusyoPipe,
    DateDurationPipe
  ],
  imports: [
    SharedModule,
    SgKdSharedRoutingModule,
    SgBaseSharedModule,
  ],
  exports: [
    BillDispZyuusyoPipe,
    DateDurationPipe
  ],
  providers: [
  ]
})
export class SgKdSharedModule { }
